export default __webpack_public_path__ + "static/xtingles-7e6531c5365b9413581613d2475dfb88.png";